import { Grid } from '@mui/material';
import Decor from '@assets/icons/decor.svg';
import React, { FC } from 'react';

export const TopLine: FC = () => {
  return (
    <Grid
      container={true}
      sx={{
        position: 'static',
        backgroundImage: `url(${Decor})`,
        minHeight: '6px',
      }}
    />
  );
};
